module.exports = __webpack_public_path__ + "static/media/Guatemala_10Dol_Favorito.8a62a7ba.jpg";